import { API_BASE_URL } from './config';
import { apiFetch, renderTransitWidget, renderError } from './helpers';
import type { TrainDeparturesResponse } from './types';

export async function fetchTrainDepartures(): Promise<void> {
    const container = document.getElementById('train-departures');
    if (!container) return;

    try {
        const response = await apiFetch(`${API_BASE_URL}/traindepartures`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data: TrainDeparturesResponse = await response.json();
        renderTransitWidget(container, data.alerts, data.departures, 'train', 'Ei lähteviä junia.');
    } catch (error) {
        renderError(container, 'train', 'Could not load train departures.', error);
    }
}
